module.exports = __webpack_public_path__ + "c523125484fc6e0a1f261bacbf57102e.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/thumbnail/public/news/img3_0.jpg
// module id = 559
// module chunks = 0